// extracted by mini-css-extract-plugin
module.exports = {"blockVideoWr":"Common_blockVideoWr__2gcT1","blockImageWr":"Common_blockImageWr__3r2gy"};